module.exports = __webpack_public_path__ + "images/icono1-hombre-con-manzana.jpg";